export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_RAW = 'UPDATE_USER_RAW';
export const CHANGE_OBRA = 'CHANGE_OBRA';
export const SET_AUTH = 'SET_AUTH';
export const UNSET_AUTH = 'UNSET_AUTH';
export const USER_REQUESTED = 'USER_REQUESTED';
export const USER_RECEIVED = 'USER_RECEIVED';
export const USER_REQUEST_FAILED = 'USER_REQUEST_FAILED';
